// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"2181":"css/admin-app.7047","9465":"css/app.7047"}[chunkId] + ".css";
};